import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { GameInstanceService } from 'src/app/services/game-instance.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/state/userState/user.service';
import { GameQuery } from 'src/app/state/gameState/game.query';
import { createTimeline } from 'animejs';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-presentation-of-mission-page',
  templateUrl: './presentation-of-mission.page.html',
  styleUrls: ['./presentation-of-mission.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PresentationOfMissionPage implements OnInit {
  // @ViewChild('phaserWrapper') phaserWrapper!: ElementRef;
  options: AnimationOptions;

  index = signal(0);
  presidentPath: string;
  flag = signal(false);
  animations: any[] = [];
  timeoutId: any;
  isInformational = signal(false);
  topicTitle = '';
  private ai: AnimationItem;
  constructor(
    private router: Router,
    private userService: UserService,
    private gameQuery: GameQuery
  ) {}

  ngOnInit() {
    this.gameQuery.president$.pipe(untilDestroyed(this)).subscribe((path) => {
      this.presidentPath = path;
      const animePresidentPath = path.slice(0, path.indexOf('.'));
      const jsonTxt = '.json';
      this.options = {
        path:
          '/assets/testAnimations/presidents/' + animePresidentPath + jsonTxt,
      };
    });
    this.isInformational.set(this.gameQuery.getCurrentTopicIsInformational());
    if (this.isInformational()) {
      this.topicTitle = this.gameQuery.getCurrentTopic().title;
    }
  }

  ionViewWillEnter() {}
  ionViewWillLeave() {}

  ionViewDidEnter() {
    this.animationTexts();
  }

  nextPopUp() {
    this.index.update(i => i + 1);
    this.animationTexts();
  }

  animationTexts() {
    this.flag.set(false);
    const startAnimation = (page: number) => {
      this.animations.forEach((anim) => anim.pause());
      this.animations = [];
      this.ai.play();
      this.animations.push(
        createTimeline({ loop: false }).add(`.anim-a .word`, {
          scale: [4, 1],
          opacity: [0, 1],
          translateZ: 0,
          ease: 'outExpo',
          delay: (el, i) => {
            this.setSpeed((120 * i) / 1000);
            return 120 * i;
          },
          onComplete: () => {
            createTimeline({ loop: false }).add(`.anim-b .word`, {
              scale: [4, 1],
              opacity: [0, 1],
              translateZ: 0,
              ease: 'outExpo',
              delay: (el, i) => {
                this.setSpeed((120 * i) / 1000);
                return 120 * i;
              },
              onComplete: () => {
                createTimeline({ loop: false }).add(`.anim-c .word`, {
                  scale: [4, 1],
                  opacity: [0, 1],
                  translateZ: 0,
                  ease: 'outExpo',
                  delay: (el, i) => {
                    this.setSpeed((120 * i) / 1000);
                    return 120 * i;
                  },
                  onComplete: () => {
                    if (page !== 2) {
                      this.ai.stop();
                      return;
                    }
                    this.flag.set(true);
                    createTimeline({ loop: false }).add(`.anim-d .word`, {
                      scale: [4, 1],
                      opacity: [0, 1],
                      translateZ: 0,
                      ease: 'outExpo',
                      delay: (el, i) => {
                        this.setSpeed((120 * i) / 1000);
                        return 120 * i;
                      },
                      onComplete: () => {
                        createTimeline({ loop: false }).add(`.anim-e .word`, {
                          scale: [4, 1],
                          opacity: [0, 1],
                          translateZ: 0,
                          ease: 'outExpo',
                          delay: (el, i) => {
                            this.setSpeed((120 * i) / 1000);
                            return 120 * i;
                          },
                          onComplete: () => {
                            this.ai.stop();
                          },
                        });
                      },
                    });
                  },
                });
              },
            });
          },
        })
      );
    };
    setTimeout(() => startAnimation(this.index()), 200);
  }

  animationCreated(animationItem: AnimationItem): void {
    this.ai = animationItem;
  }

  setSpeed(num: number) {
    if (num > 0.8) {
      num = 0.8;
    }
    this.ai.setSpeed(num);
  }

  goToProposal() {
    this.router.navigate(['/presentation_proposal']);
  }
}
